import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DtoContractClientForViewVM } from '../../../Model/contracts-warranties/DtoContractClientForViewVM';

@Component({
  selector: 'app-submit-warranty',
  templateUrl: './submit-warranty.component.html',
  styleUrl: './submit-warranty.component.scss'
})
export class SubmitWarrantyComponent {
  @Input() ContractsList: DtoContractClientForViewVM[] = [];
  @Output() chooseContract = new EventEmitter<boolean>();
  @Output() selectedContract = new EventEmitter<DtoContractClientForViewVM>();
  isChooseContract?: boolean = false;

  ChooseContract(contract?: DtoContractClientForViewVM) {
    this.isChooseContract = true;
    this.chooseContract.emit(this.isChooseContract);
    this.selectedContract.emit(contract);
  }
}
